import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test')
  },
  {
    path: '/pc',
    name: 'home',
    component: () => import('@/views/pc/index')
  },
  {
    path: '/wx',
    name: 'wx',
    component: () => import('@/views/wx/index')
  }
]

const router = new VueRouter({
  routes
})
export default router
